import React from 'react'
import { X } from 'lucide-react'
import { cn } from 'lib/utils'
import type { StagedImage } from './imageUploadWizard.types'

interface StagedImageGridProps {
	images: StagedImage[]
	onRemove?: (id: string) => void
	className?: string
}

/**
 * Thumbnails of the files the user has picked but not yet uploaded.
 *
 * Removal is offered here because the wizard defers the upload until Confirm —
 * with the old uploader a mis-picked file was already in Cloudinary before the
 * user could react.
 */
const StagedImageGrid: React.FC<StagedImageGridProps> = ({ images, onRemove, className }) => {
	if (images.length === 0) return null

	return (
		<div className={cn('grid grid-cols-3 gap-2 sm:grid-cols-4', className)}>
			{images.map(image => (
				<div
					key={image.id}
					className="group relative overflow-hidden rounded-md border border-border bg-muted"
				>
					<img
						src={image.preview}
						alt={image.file.name}
						className="h-20 w-full object-cover"
					/>
					{onRemove && (
						<button
							type="button"
							aria-label={'Remove ' + image.file.name}
							onClick={() => onRemove(image.id)}
							className="absolute right-1 top-1 rounded-full bg-black/60 p-0.5 text-white opacity-0 transition-opacity group-hover:opacity-100 focus:opacity-100"
						>
							<X className="h-3 w-3" />
						</button>
					)}
					<div className="truncate px-1.5 py-1 text-[11px] text-muted-foreground">
						{image.file.name}
					</div>
				</div>
			))}
		</div>
	)
}

export default StagedImageGrid
